var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgEPostBilling = function SvgEPostBilling(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 15,
    "data-width-20": 19,
    "data-width-24": 22,
    "data-width-72": 65,
    viewBox: "0 0 14.4 14.6",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.2,
    d: "M6.167 13.933V12.6m2.666 1.333V12.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.5 12.6v.5H7v-.5zm2-.5a.5.5 0 0 0 0 1zm2.333-9.333a.5.5 0 1 0 0 1zm-7 0a.5.5 0 0 0 0 1zM5.167 12.1a.5.5 0 0 0 0 1zm4 1a.5.5 0 1 0 0-1zM6 6.767V12.6h1V6.767zm.5 5.333H1.989v1H6.5zM1 10.863V6.767H0v4.096zm.989 1.237C1.512 12.1 1 11.62 1 10.863H0c0 1.16.82 2.237 1.989 2.237zM3.5 3.767c1.311 0 2.5 1.268 2.5 3h1c0-2.134-1.497-4-3.5-4zm0-1c-2.003 0-3.5 1.866-3.5 4h1c0-1.732 1.189-3 2.5-3zm9.833 4v4.116h1V6.767zm-.971 5.333H8.5v1h3.862zm.971-1.217c0 .747-.504 1.217-.971 1.217v1c1.159 0 1.971-1.067 1.971-2.217zm1-4.116c0-2.134-1.497-4-3.5-4v1c1.312 0 2.5 1.268 2.5 3zm-10.5-3h7.334v-1H3.833zM5.167 13.1h4v-1h-4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.2,
    d: "M2.5 9.933h2m5.333-4.077V2.874m0 0v-1.85A.33.33 0 0 1 10.1.7l.324-.062c.392-.076.797-.04 1.17.104l.053.02c.37.142.774.169 1.158.076a.294.294 0 0 1 .362.285v1.48a.34.34 0 0 1-.262.333l-.044.01c-.421.102-.863.073-1.267-.082a2.13 2.13 0 0 0-1.17-.104z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEPostBilling);
export default ForwardRef;